export default "__VITE_PUBLIC_ASSET__7e093b06__"